const hasSlider = document.querySelector('.js-affiliate-programs__slider .swiper');

if (hasSlider) {
	Promise.all([
		import('swiper'),
		import(
			/* webpackExports: ["Navigation", "Pagination"] */
			'swiper/modules'
		),
	])
		.then(([{ default: Swiper }, { Navigation, Pagination }]) => {
			const swiper = new Swiper('.js-affiliate-programs__slider .swiper', {
				slidesPerView: 'auto',
				pagination: {
					el: '.js-affiliate-programs__slider .swiper-pagination',
				},
				navigation: {
					prevEl: '.js-affiliate-programs__slider-arrow-left',
					nextEl: '.js-affiliate-programs__slider-arrow-right',
				},
				modules: [Navigation, Pagination],
			});
		})
		.catch((err) => console.error(err));
}
